export const formatHourToValidate = (hour: string): string => {
  const splited: string[] = hour.split('')
  splited[2] = ':'
  return splited.join('')
}